<template>
    <Card class="layout-card">
        <div style="margin-bottom: 10px;">
            <div class="search-form">
                <Select v-model="metrics" multiple placeholder="请选择指标" :max-tag-count="1" @on-change="changeMetric"
                    label-in-value filterable style="width: 17%;">
                    <template #prefix>
                        <a style="font-size: 12px;padding: 0 5px;white-space: nowrap;" @click="(e) => {
                            e.preventDefault()
                            e.stopPropagation();
                            if (metric.length === homeData.length) {
                                metrics = []
                                changeMetric([])
                            }
                            else {
                                const data = homeData.map(i => i.value)
                                metrics = data
                                changeMetric(homeData)
                            }

                        }">{{ metric.length === homeData.length ? '清空' : '全选' }}</a>
                    </template>
                    <Option v-for="(i, index) in homeData" :key="index" :value="i.value">{{ i.label }}</Option>
                </Select>
                <div>
                    <Select placeholder="维度" style="width: 70px" v-model="searchForm.timeType">
                        <Option :value="0">日</Option>
                        <Option value="week">周</Option>
                        <Option value="month">月</Option>
                    </Select>
                    <DatePicker :editable="false" format="yyyy-MM-dd" type="daterange" style="width: 200px;" placeholder="请选择日期"
                        :value="listDate" @on-change="getListDate" :clearable="false"></DatePicker>
                </div>

                <Select v-model="searchForm.timeZone" placeholder="请选择时区" style="width: 8%;">
                    <!-- <Option :value="8">东八区</Option>/ -->
                    <Option :value="-8">西八区</Option>
                </Select>
                <Select v-model="searchForm.adsCamStatus" placeholder="请选择状态" style="width: 8%;" clearable>
                    <!-- <Option :value="8">东八区</Option>/ -->
                    <Option value="ACTIVE">开启</Option>
                    <Option value="PAUSED">关闭</Option>
                </Select>
                <Select v-model="person" placeholder="请选择优化师" filterable :max-tag-count="1" multiple
                    style="width: 230px;" :disabled="!searchOptions.person.length"
                    @on-change="searchForm.personIds = $event">
                    <template #prefix>
                        <a v-show="searchOptions.person.length"
                            style="font-size: 12px;padding: 0 5px;white-space:nowrap" @click="(e) => {
                                e.preventDefault()
                                e.stopPropagation();
                                if (person.length === searchOptions.person.length) {
                                    searchForm.personIds = []
                                    changePerson([])
                                }
                                else {
                                    const data = [...searchOptions.person.map(i => i.id)]
                                    $set(searchForm, 'personIds', data)
                                    changePerson(data)
                                }

                            }">{{ person.length !== searchOptions.person.length ? '全选' : '清空' }}</a>
                    </template>
                    <Option v-for="(i, index) in searchOptions.person" :key="index" :value="i.id">{{ i.dictName }}
                    </Option>
                </Select>
                <Select v-model="campaign" placeholder="请选择广告系列" filterable :max-tag-count="1" multiple
                    style="width: 500px;" :disabled="!searchOptions.campaign.length"
                    @on-change="searchForm.advertiseSeriesIds = $event">
                    <template #prefix>
                        <a v-show="searchOptions.campaign.length"
                            style="font-size: 12px;padding: 0 5px;white-space:nowrap" @click="(e) => {
                                e.preventDefault()
                                e.stopPropagation();
                                if (campaign.length === searchOptions.campaign.length) {
                                    searchForm.advertiseSeriesIds = []
                                    changeCampaign([])
                                }
                                else {
                                    const data = [...searchOptions.campaign.map(i => i.campaignId)]
                                    $set(searchForm, 'advertiseSeriesIds', data)
                                    changeCampaign(data)
                                }

                            }">{{ campaign.length !== searchOptions.campaign.length ? '全选' : '清空' }}</a>
                    </template>
                    <Option v-for="(i, index) in searchOptions.campaign" :key="index" :value="i.campaignId">{{
                        i.campaignName }}
                    </Option>
                </Select>
                <Input style="width: 200px;" placeholder="广告系列ID" v-model="campaignId" />
                <Select placeholder="渠道" clearable v-model="searchForm.channel" style="width: 200px">
                    <Option :value="0">facebook</Option>
                    <Option :value="1">tiktok</Option>
                    <Option :value="2">其他</Option>
                </Select>
                <Select placeholder="投放类型" clearable v-model="searchForm.advertiseType" style="width: 200px">
                    <Option :value="0">W2A</Option>
                    <Option :value="1">直投</Option>
                </Select>
                <Select v-model="searchForm.langId" placeholder="请选择语言" style="width: 200px" clearable>
                    <Option v-for="(item, index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
                </Select>
                <Button type="primary" @click="getData()">查询</Button>
                <Button style="width: auto;" @click="handleReset()">重置</Button>
                <Button style="width: auto;" type="warning" @click="handleExport()" :loading="exportLoading">导出</Button>
            </div>
        </div>
        <div>
            <Table border :data="tableData" :columns="column" v-if="columns.length > 1" :loading="showTable"
                show-summary ref="tableRef" :summary-method="handleSummary" @on-sort-change="test">
                <template #status="{ row, index }">
                    <div>
                        <a v-if="row.advertiseSeries" :style="{ color: row.adsCamStatus ? '' : 'orange' }"
                            @click="handleChangeStatus(row, index)">
                            {{
                                row.adsCamStatus || '加载中'
                            }}
                        </a>
                        <a v-else style="color: orange" @click="handleChangeStatus(row, index)">加载中</a>
                    </div>
                </template>
                <Pages slot="footer" :page="page" :func="getData" :pArr="[31, 50]"></Pages>
            </Table>
            <div v-else style="text-align: center;font-size: 18px;padding: 20px 0">请选择查询项</div>
        </div>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getLangList } from '@/api/lang'
import { getCampainInit, getPersonInit, gePitcherDataColor, changePitcherStatus, exportPitcherDataColor } from '@/api/data'
import dayjs from 'dayjs'
import { utils, writeFile } from 'xlsx'
import home, { homeData } from '.'
import { cloneDeep } from 'lodash'
export default {
    name: 'pitcherColor',
    components: {
        Pages
    },
    data() {
        return {
            homeData,
            editVisible: false,
            sum: [],
            form: {},
            searchForm: {
                personIds: [],
                advertiseSeriesIds: [],
                timeType: 0,
                timeZone: -8
            },
            listDate: [],
            submitLoading: false,
            langList: [],
            showTable: false,
            page: {
                current: 1,
                size: 31,
                total: 0
            },
            metric: [],
            exportLoading: false,
            metrics: [],
            tableData: [],
            column: [],
            realData: [],
            campaign: [],
            campaignId: '',
            person: [],
            orders: {
                key: '',
                order: ''
            },
            searchOptions: {
                campaign: [],
                person: []
            },
            sortKey: ''
        }
    },
    computed: {
        buttonMenu() {
            const li = this.$store.getters.getMenuRules('data')
            const obj = {}
            li.forEach(i => {
                obj[i.menuPath] = true
            })
            return obj
        },
        columns() {
            const li = []
            const obj = {
                '日期': true,
                '优化师名称': true,
                '广告系列名称': true,
                '广告状态': true,
                '投放金额': true,
                '渠道': true,
                '语言': true,
                '广告系列ID': true,
                '广告组ID': true,
                '广告组名称': true,
                '广告名称': true,
                '广告ID': true,
            }
            const res1 = this.metric.filter(i => {
                return obj[i.label]
            }).map(i => {
                return {
                    title: i.label,
                    key: i.value.split(',')[1],
                    width: i.width ? i.width : (i.label.length > 5 ? 140 : 100),
                    needCalc: i.needCalc,
                    tooltip: !!i.tooltip,
                    tooltipMaxWidth: i.tooltipMaxWidth,
                    slot: i.slot,
                    resizable: i.resizable,
                    calc: i.calc,
                    sortable: !i.sortable ? false : 'custom',
                    render: i.render
                }

            })
            const res2 = this.metric.filter(i => {
                return !obj[i.label]
            }).map(i => {
                return {
                    title: i.label,
                    key: i.value.split(',')[1],
                    width: i.width ? i.width : (i.label.length > 5 ? 140 : 100),
                    needCalc: i.needCalc,
                    slot: i.slot,
                    calc: i.calc,
                    sortable: 'custom',
                    render: i.render
                }

            })

            if (this.campaign.length) {
                li.push({
                    title: '链接点击率',
                    key: 'linkClickRate',
                    needCalc: true,
                    width: 120,
                    render: (h, params) => {
                        return <div>
                            {params.row.linkClickRate ? (Number(params.row.linkClickRate) * 100).toFixed(2) + '%' : 0}
                        </div>
                    },
                    sortable: 'custom',
                },
                    {
                        title: '链接点击量',
                        key: 'linkClickCount',
                        width: 120,
                        sortable: 'custom',
                    },
                    {
                        title: '千次展示费用',
                        key: 'thousandShowCost',
                        width: 130,
                        sortable: 'custom',
                    })
            }
            this.searchForm.sortKeyId = null
            this.searchForm.sortDesc = null

            return [{
                title: '序号',
                key: 'index',
                fixed: 'left',
                render: (h, params) => {

                    return <div>
                        {(this.page.current - 1) * this.page.size + params.row._index + 1}
                    </div>
                },
                width: 100
            }, ...res1, ...li, ...res2].map(i => ({
                ...i,
                resizable: true,
            }))
        }
    },
    methods: {
        test({ column, key, order }) {
            this.sortKey = key

            homeData.forEach(el => {
                const [k, v] = el.value.split(',')
                if (v == this.sortKey) {

                    this.searchForm.sortKeyId = this.sortKey.includes('person') ? 2 : k
                }
            });
            if (key == 'linkClickRate') this.searchForm.sortKeyId = 29
            if (key == 'linkClickCount') this.searchForm.sortKeyId = 30
            if (key == 'thousandShowCost') this.searchForm.sortKeyId = 31
            if (order == 'asc') {
                this.searchForm.sortDesc = false
            } else {
                this.searchForm.sortDesc = true
            }
            if (order == 'normal') {
                this.searchForm.sortKeyId = null
                this.searchForm.sortDesc = null

            }
            this.getData()
        },
        handleChangeStatus(params, index) {
            if (!params.campaignId) {
                this.$Message.error('该数据无广告系列')
                return
            }
            changePitcherStatus(params.campaignId).then(r => {
                this.$set(this.tableData[index], 'adsCamStatus', r.data)
                this.$Message.success('刷新成功')
            })
        },
        handleGetLang() {
            getLangList({ current: -1, size: -1 }).then(r => {
                this.langList = r.data.records
            })
        },
        handleExport() {
            let advertiseSeriesIds = []
            if (this.campaignId) {
                advertiseSeriesIds = [this.campaignId]
            } else {
                advertiseSeriesIds = this.searchForm.advertiseSeriesIds && this.searchForm.advertiseSeriesIds.length ? [...this.searchForm.advertiseSeriesIds].map(i => i.split(',')[0]) : []
            }

            this.exportLoading = true
            exportPitcherDataColor({
                ...this.searchForm,
                timeType: !this.searchForm.timeType ? null : this.searchForm.timeType,
                distinguishDate: this.metrics.indexOf('1,statDate') > -1,
                personIds: this.searchForm.personIds && this.searchForm.personIds.length ? [...this.searchForm.personIds] : [],
                advertiseSeriesIds
            }).then(r => {
                const link = document.createElement('a')
                this.exportLoading = false
                link.style.display = 'none'

                // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'), r.data.fileUrl.length)
                link.href = r.data.fileUrl
                link.setAttribute('download', r.data.fileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })

            // const headerRow = this.column.map(header => header.title);
            // let advertiseSeriesIds = []
            // if(this.campaignId){
            //     advertiseSeriesIds = [this.campaignId]
            // }else{
            //     advertiseSeriesIds = this.searchForm.advertiseSeriesIds && this.searchForm.advertiseSeriesIds.length ? [...this.searchForm.advertiseSeriesIds].map(i => i.split(',')[0]) : []
            // }

            // gePitcherDataColor({
            //     ...this.searchForm,
            //     current:1,
            //     size: 20000,
            //     distinguishDate: this.metrics.indexOf('1,statDate')>-1,
            //     personIds: this.searchForm.personIds && this.searchForm.personIds.length ? [...this.searchForm.personIds] : [],
            //     advertiseSeriesIds
            // }).then(r=>{

            //     const dataRows = r.data.pageData.records.map((item,index) => {
            //     return this.column.map(header => {
            //     // 处理嵌套属性（如：'user.address.city'）
            //     const prop = header.key;
            //     if(header.key=='index') return index+1
            //     return item[prop]?(header.render?Number(item[prop]*100).toFixed(2)+'%':item[prop]) : ''; // 空值处理
            //     });
            // });
            // const worksheetData = [
            //     headerRow,
            //     ...dataRows
            // ];
            // const worksheet = utils.aoa_to_sheet(worksheetData);
            // const workbook = utils.book_new();
            // utils.book_append_sheet(workbook, worksheet, "投手报表数据");

            // // 6. 生成Excel文件并下载
            // writeFile(workbook, "投手报表数据.xlsx");
            // })

        },
        handleSummary({ columns, data }) {

            const res = {}
            const sums = {}
            columns.forEach((column, index) => {
                const key = column.key
                if (!index) {
                    sums[key] = {
                        key,
                        value: '合计'
                    }
                    return
                }
                sums[key] = {
                    key,
                    value: column.needCalc ? ((this.sum[key] * 100).toFixed(2) + '%' || '-') : this.sum[key]
                }
            })

            return sums

        },
        changeMetric(e) {
            const values = e.map(i => i.value)

            localStorage.setItem('users-color', JSON.stringify(values))
            this.metric = homeData.filter(i => values.indexOf(i.value) > -1)
            this.searchForm.fieldIds = values.map((i => i.split(',')[0]))
        },
        changeCampaign(e) {
            this.campaign = e
        },
        changePerson(e) {
            this.person = e
        },
        getListDate(data) {
            this.listDate = data
            this.searchForm.startDate = data[0]
            this.searchForm.endDate = data[1]
        },
        getData(current) {
            this.showTable = true
            this.column = this.columns
            if (!current) {
                this.page.current = 1
            } else {
                this.page.current = current
            }
            let advertiseSeriesIds = []
            if (this.campaignId) {
                advertiseSeriesIds = [this.campaignId]
            } else {
                advertiseSeriesIds = this.searchForm.advertiseSeriesIds && this.searchForm.advertiseSeriesIds.length ? [...this.searchForm.advertiseSeriesIds].map(i => i.split(',')[0]) : []
            }

            gePitcherDataColor({
                ...this.searchForm,
                ...this.page,
                timeType: !this.searchForm.timeType ? null : this.searchForm.timeType,
                distinguishDate: this.metrics.indexOf('1,statDate') > -1,
                personIds: this.searchForm.personIds && this.searchForm.personIds.length ? [...this.searchForm.personIds] : [],
                advertiseSeriesIds
            }).then(({ data }) => {
                this.tableData = data.pageData.records
                this.page.total = data.pageData.total
                this.sum = data.sum
                if (process.env.NODE_ENV === 'development') {
                    //     this.realData = [
                    //     {
                    //     "createTime": "2025-05-23",
                    //     "countryCode": null,
                    //     "channel": null,
                    //     "os": null,
                    //     "campaign": null,
                    //     "cost": 7226.63,
                    //     "activation": 1556,
                    //     "registrationCount": null,
                    //     "activationCost": 4.64,
                    //     "registrationCost": null,
                    //     "firstRechargeCount": 175,
                    //     "firstCostCount": 41.3,
                    //     "firstRechargeCost": 4088.67,
                    //     "firstPayRate": 0.11,
                    //     "firstARPU": 23.36,
                    //     "firstROI": 0.57,
                    //     "thirdROI": 0.57,
                    //     "eighthROI": 0.57,
                    //     "fifthROI": 0.57,
                    //     "totalROI": 0.57,
                    //     "totalRecharge": 7276.73,
                    //     "thirdRecharge": 4088.67,
                    //     "eighthRecharge": 4088.67,
                    //     "fifthRecharge": 4088.67,
                    //     "thirtyRecharge": 4088.67,
                    //     "sixtyRecharge": 4088.67,
                    //     "allRecharge": 4088.67,
                    //     "threeTimesGrowth": 1,
                    //     "eightTimesGrowth": 1,
                    //     "fourthTimesGrowth": 1,
                    //     "thirtyTimesGrowth": 1,
                    //     "sixtyTimesGrowth": 1,
                    //     "gross": null,
                    //     "dau": null,
                    //     "day1Retention": null,
                    //     "day3Retention": null
                    // }
                    //     ]
                    //     this.realData = Array.from({length:33},()=>{
                    //       return {...this.realData[0]}
                    //     })
                    //     this.$set(this.realData[9],'cost',123)
                    //     this.$set(this.realData[32],'cost',122223)
                    //     this.page.total = this.realData.length
                }
                // this.getTable()
                this.showTable = false
            })
        },
        // getTable(page) {
        //     if (page) this.page.current = page
        //     else this.page.current = 1

        //     const tb = cloneDeep(this.realData)
        //     if (this.orders.order && this.orders.order != 'normal') {
        //         if (this.orders.order == 'asc') {
        //             tb.sort((a, b) => {
        //                 return a[this.orders.key] - b[this.orders.key]
        //             })
        //         } else {
        //             tb.sort((a, b) => {
        //                 return b[this.orders.key] - a[this.orders.key]
        //             })
        //         }
        //     }
        //     this.tableData = tb.slice((this.page.current - 1) * this.page.size, this.page.current * this.page.size)


        // },
        handleGetDataInit() {
            getCampainInit({current:1,size: 1000000}).then(r => {
                this.searchOptions.campaign = r.data.records

            })
            getPersonInit().then(r => {
                this.searchOptions.person = r.data.records
            })
        },
        handleReset() {

            this.searchForm = {
                channel: '',
                sortKeyId: this.searchForm.sortKeyId,
                sortDesc: this.searchForm.sortDesc,
                timeType: 0,
                adsCampaign: [],
                personIds: [],
                timeZone: -8
            }
            this.getListDate([dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])
            // this.$refs.tableRef.handleSort(this.column.findIndex(i=>i.key==this.sortKey),'normal')
            this.channels = []
            this.person = []
            this.campaign = []
            this.metrics = homeData.filter(i => !i.disabled).map(i => i.value)
            this.changeMetric(homeData.filter(i => !i.disabled))
            this.sortKey = ''
            this.handleGetDataInit()
        }
    },
    mounted() {
        this.handleGetLang()
        // this.getData()
        const metric = localStorage.getItem('users-color')
        if (!metric) {
            this.metrics = homeData.filter(i => !i.disabled).map(i => i.value)
            this.changeMetric(homeData.filter(i => !i.disabled))

        } else {
            this.metrics = JSON.parse(metric)
            this.metric = homeData.filter(i => JSON.parse(metric).indexOf(i.value) > -1)
            this.searchForm.fieldIds = this.metrics.map((i => i.split(',')[0]))
        }
        this.handleGetDataInit()
        this.column = this.columns
        this.getListDate([dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])
    },
    activated() {
        this.handleGetDataInit()
    }
}
</script>

<style scoped lang="less">
.search-form {
    display: flex;
    flex-wrap: wrap;

    &>* {
        margin: 0 5px 10px;

    }
}

.layout-card {
    /deep/ .ivu-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
}

/deep/.ivu-table td,
.ivu-table th {
    height: 20px;
}

/deep/.ivu-table {
    .ivu-table-tbody {
        .ivu-table-row:last-child {
            height: 30px;

            td {
                vertical-align: top;
                height: 30px;
            }
        }

    }
}
</style>